import React from "react";
import { useHistory } from "react-router-dom";
import EnlaceAModal from "./EnlaceAModal";
import EnlaceADescarga from "./EnlaceADescarga";
import { getAtributo } from "../../../context/FuncionesContext";
import Default from "./Default";
import { construirEnlace } from "../../../helper/funciones";

const Enlace = ({ data, cab, hijos, campokey, id_elemento, qsBody }) => {
  // atributos:
  // enlace, enlace_alias, enlace_parametro, enlace_parametros_alias, enlace_id_a, enlace_id_a_alias,
  // enlace_externo, target.

  const history = useHistory();

  const nombre = getAtributo("nombre", data, cab);
  const boton_texto = getAtributo("boton_texto", data, cab);
  const e = getAtributo("enlace", data, cab);
  const id_a = getAtributo("enlace_id_a", data, cab);

  // const e = cab.enlace
  //   ? cab.enlace_alias
  //     ? data[cab.enlace_alias]
  //       ? data[cab.enlace_alias]
  //       : cab.enlace
  //     : cab.enlace
  //   : undefined;

  let parametros_valores = getAtributo("enlace_parametros", data, cab)
    ?.toString()
    .split(",");

  if (cab.enlace_parametros_alias) {
    parametros_valores = cab.enlace_parametros_alias
      .split(",")
      .map((alias) => data[alias]);
  }

  const en = getAtributo("enlace_parametros_nombres", data, cab)
    ?.toString()
    .split(",");

  // const id_a = data[cab.enlace_id_a_alias]
  //   ? data[cab.enlace_id_a_alias]
  //   : cab.enlace_id_a
  //   ? cab.enlace_id_a
  //   : "";

  let parametros = "";
  let paramObj = {};
  if (parametros_valores && en) {
    parametros = "?";
    parametros_valores.forEach((qP, i) => {
      parametros = parametros.concat("&" + en[i] + "=" + qP);
      paramObj[en[i]] = qP;
    });
  }

  // if (cab.enlace_id_a) {
  //   return process.env.PUBLIC_URL + e + id_a + parametros;
  // }

  const enlaceConstruido = construirEnlace(data, cab);
  let enlace = enlaceConstruido.enlace_completo;

  // si es externo y empieza con "/http..." le saco la barra inicial
  if (
    cab.enlace_externo === "s" &&
    /^\/https?:\/\//.test(enlace)
  ) {
    enlace = enlace.slice(1);
  }

  const linkToPantalla = () => {
    if (cab.target === "_blank") {
      const url = `/#/${e}${id_a}${parametros}`;
      return window.open(url, "_blank");
    }

    history.push({
      pathname: `/${e}${id_a}`,
      search: parametros,
    });
  };

  const disabled = getAtributo("disabled", data, cab);
  if (disabled === "s")
    return (
      <Default
        data={data}
        cab={cab}
        hijos={hijos}
        campokey={campokey}
        id_elemento={id_elemento}
      />
    );

  if (cab.target === "modal") {
    return (
      <EnlaceAModal
        nombre={nombre}
        paramObj={paramObj}
        cab={cab}
        data={data}
        id_elemento={id_elemento}
        qsBody={qsBody}
        enlace_id_a={id_a}
        campokey={campokey}
      />
    );
  }

  if (cab.target === "_blank" && cab.enlace_externo === "s") {
    return (
      <div id={id_elemento} className="Listado_Switch_Enlace">
        <Ancla
          cab={cab}
          enlace={enlace}
          data={data}
          hijos={hijos}
          target={cab.target}
        />
      </div>
    );
  }

  if (cab.target === "descarga") {
    const archivo_nombre =
      data[cab.id_a + "_archivo_nombre"] ??
      cab.archivo_nombre ??
      e.split("/").pop();
    return (
      <div
        id={id_elemento}
        className={`Listado_Switch_Enlace ${data[cab.id_a + "_className"]}`}
        style={{}}
      >
        <a
          id={id_elemento + "_a"}
          href={e}
          rel="noopener noreferrer"
          download={archivo_nombre}
        >
          <div
            style={{
              textAlign: cab.align ?? "center",
            }}
          >
            {cab.imagen_url ? (
              <img
                style={{ cursor: "pointer" }}
                height={"40px"}
                src={cab.imagen_url}
                alt="imagen"
              />
            ) : (
              <>
                {boton_texto}
              </>
            )}

            {hijos}
          </div>
        </a>
      </div>
    );
  }
  if (cab.target?.toLowerCase() === "descargapost") {
    return (
      <EnlaceADescarga
        id_elemento={id_elemento}
        data={data}
        cab={cab}
        e={e}
        hijos={hijos}
      />
    );
  }

  return (
    <div
      id={id_elemento}
      className={cab.className || "Vista_Switch_Enlace"}
    >
      {cab.enlace_externo === "s" ? (
        <Ancla
          cab={cab}
          enlace={enlace}
          data={data}
          hijos={hijos}
          target="_self"
        />
      ) : (
        <div onClick={linkToPantalla}>
          <div
            style={{
              textAlign: "center",
            }}
          >
            {cab.imagen_url ? (
              <img
                style={{ cursor: "pointer" }}
                height={"40px"}
                src={cab.imagen_url}
                alt="imagen"
              />
            ) : (
              <>
                {boton_texto}
              </>
            )}

            {hijos}
          </div>
        </div>
      )}
    </div>
  );
};

export default Enlace;

const Ancla = ({ cab, enlace, data, hijos, target }) => {
  const AnclaWrapper = ({ children }) => (
    <a target={target} href={enlace} rel="noopener noreferrer">
      {children}
    </a>
  );
  const boton_texto = getAtributo("boton_texto", data, cab)
  return (
    <AnclaWrapper>
      <div
        style={{
          textAlign: "center",
        }}
        className={cab.className}
      >
        {cab.imagen_url ? (
          <img
            style={{ cursor: "pointer" }}
            height={"40px"}
            src={cab.imagen_url}
            alt="imagen"
          />
        ) : (
          <>
            {boton_texto}
          </>
        )}

        {hijos}
      </div>
    </AnclaWrapper>
  );
};
